import type { FC, SVGAttributes } from 'react';
import React from 'react';

export const IconArrowRight: FC<SVGAttributes<SVGElement>> = props => (
    <svg
        fill="none"
        height="30"
        viewBox="0 0 16 30"
        width="16"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M1.354 29.354L15.707 15L1.354 0.645996L0.645996 1.354L14.293 15L0.645996 28.646L1.354 29.354Z"
            fill="#0B1F35"
        />
    </svg>
);
